module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"freeText":"Free text","noFreeText":"There are no free texts yet.","invoice":"Invoice","waybill":"Waybill","loadingList":"Loading list","internal":"Internal","goodsList":"Goods list"},"no":{"freeText":"Fritekst","noFreeText":"Det er ingen fritekster ennå.","invoice":"Faktura","waybill":"Fraktbrev","loadingList":"Lasteliste","internal":"Internt","goodsList":"Godsliste"}}')
  delete Component.options._Ctor
}
